import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/goalsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

export const ModuleViewFilter = () => {
  const dispatch = useDispatch();
  const selectedModuleView = useSelector((state) => state.newGoals.selectedModuleView);
  const moduleViewOptions = useSelector((state) => state.newGoals.moduleViewOptions);

  return (
    <MultiSelectDropdown
      options={moduleViewOptions}
      selectedFilters={selectedModuleView}
      placeholder="Select Range"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (selectedModuleView !== data) {
          dispatch(actionCreators.updateModuleView(data));
        }
      }}
    />
  );
};
